import { TYPE_SABAY_GAME_REVENUE } from "./type";

const initialState = {
  revenue: [],
  postData: [],
};

export const reducerSabayGame = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_SABAY_GAME_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};
